import React, { FunctionComponent } from 'react';

import { CardList, Card } from 'components';
import { Text, Icon } from 'components/chroma';

import { VehicleModification } from 'scenes/motor/types';

const isSelected = (
  selectedModifications: VehicleModification[],
  vehicleModification: VehicleModification
): boolean =>
  selectedModifications.some(
    (option) => option.name === vehicleModification.name
  );

const ModificationList: FunctionComponent<{
  vehicleModifications: VehicleModification[];
  selectedModifications: VehicleModification[];
  onClick: (vehicleModification: VehicleModification) => void;
}> = ({ vehicleModifications, selectedModifications, onClick }) => (
  <CardList>
    {vehicleModifications.map((option) => (
      <Card
        key={option.name}
        id={option.name}
        selected={isSelected(selectedModifications, option)}
        center
        onClick={() => onClick(option)}
        role="button"
      >
        <Icon name="checkCircle" margin={{ right: 5 }} />
        <Text>{option.description}</Text>
      </Card>
    ))}
  </CardList>
);

export default ModificationList;
